// extracted by mini-css-extract-plugin
export default {"wrapper":"PillsFilter_wrapper__+ExxF","options-container":"PillsFilter_options-container__y7fh9","pill":"PillsFilter_pill__j2DwP"};